import React, { useContext, useEffect} from "react";
import InicioContext from "./InicioContext";


import "react-circular-progressbar/dist/styles.css";
import Nav from "./Nav";
import Progress from "./Progress";
function App() {
  const data = useContext(InicioContext);
  const {
    createCatalogo,
    Catalog,
    Catalogo,
    Finalizados,
    SelectBook,
    
    GetCatalogo,
GetFinalizados,

  } = data;

useEffect(()=>{
  
  GetCatalogo();
  GetFinalizados();
},[]);

  return (
    <div className="container">
      <Nav />

      <div className={SelectBook.titles ? "Catalogando-Progress": "Catalogando"}>
        <Catalog
          Name={"Meu Catalógo"}
          ArrayMapping={Catalogo}
          Catalogo={createCatalogo}
        />
        <Catalog
          Name={"Livros Finalizados"}
          ArrayMapping={Finalizados}
          Catalogo={createCatalogo}
          id={SelectBook.id}
        />
        {SelectBook.titles ? (
         <aside> <Progress /></aside>
        ) : null}
      </div>
    </div>
  );
}
export default App;
